import { AUTH_ROOT } from 'env'
import React, { useState } from 'react'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/styles'

import AccountsBenefitModal from 'components/account-benefits-modal'
import StepDescription from '../step-description'
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined'

export const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '60px',
  },
  coachCardWrapper: {
    margintop: '25px',
  },
  sectionTitle: {
    marginBottom: '20px',
  },
  textWrapped: {
    display: 'flex',
    flexDirection: 'column',
  },
  warningBox: {
    padding: '20px',
    background:
      'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #2196F3;',
    borderRadius: '4px',
    margin: '0 0 48px',
  },
  signInText: {
    marginTop: '10px',
    alignSelf: 'center',
  },
  learnMoreText: {
    color: '#00234B',
    fontWeight: '600',
    cursor: 'pointer',
  },
  stepContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
}))

export default ({ previousUrl }) => {
  const [isOpen, setIsOpen] = useState(false)
  const classes = useStyles()
  const authUrl = `${AUTH_ROOT}/?return_to=${encodeURIComponent(
    window.location.href,
  )}`
  const loginUrl = `${AUTH_ROOT}/login/?return_to=${encodeURIComponent(
    window.location.href,
  )}`
  return (
    <>
      <Grid item xs={12}>
        <Box flexGrow={1} display={{ xs: 'none', sm: 'flex' }}>
          <Button href={previousUrl} startIcon={<ArrowBackOutlinedIcon />}>
            BACK
          </Button>
        </Box>
      </Grid>
      <Grid container spacing={2} className={classes.stepContainer}>
        <StepDescription
          stepText="Step 2 of 3"
          title="Student"
          description="Who will be attending the session?"
        />
      </Grid>
      <Grid container spacing={2}>
        <Grid item md={8} xs={12} className={classes.textWrapped}>
          <Typography variant="body" className={classes.warningBox}>
            You must have a MyPGA account to book this session.{' '}
            <span
              onClick={() => setIsOpen(true)}
              className={classes.learnMoreText}
            >
              Learn more
            </span>
          </Typography>
          <Box display="flex">
            <Grid container spacing={2}>
              <Grid item md={5}>
                <Button
                  href={authUrl}
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{ display: 'block', textAlign: 'center' }}
                >
                  CREATE ACCOUNT
                </Button>
              </Grid>
              <Grid item md={5}>
                <Button
                  href={loginUrl}
                  variant="outlined"
                  color="primary"
                  size="large"
                  style={{ display: 'block', textAlign: 'center' }}
                >
                  Sign In
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <AccountsBenefitModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  )
}
